import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import {
  LandingPage,
  Legality,
  Pharmacies,
  Practioner,
  SuperAdmin,
} from "./modules";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/legality" element={<Legality />} />
        <Route path="/pharmacies" element={<Pharmacies />} />
        <Route path="/practioner" element={<Practioner />} />
        <Route path="/superAdmin" element={<SuperAdmin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
